export const UPDATESIDEBARTAB = 'UPDATESIDEBARTAB';
export const UPDATE_BREADCRUMB = 'UPDATE_BREADCRUMB';
export const UPDATE_IS_LOADER = 'UPDATE_IS_LOADER';
export const UPDATE_TOKEN = 'UPDATE_TOKEN';
export const SIBEBAR_LAYOUT_CHANGE = 'SIBEBAR_LAYOUT_CHANGE';
export const UPDATE_USER_INFO = 'UPDATE_USER_INFO';
export const UPDATE_TOKEN_INFO = 'UPDATE_TOKEN_INFO';
export const UPDATE_RESPONSIVE_SIDEBAR = 'UPDATE_RESPONSIVE_SIDEBAR';
export const INITIALIZE_STORE = 'INITIALIZE_STORE';
export const UPDATE_DOWNLOAD_ID = 'UPDATE_DOWNLOAD_ID';
export const UPDATE_FLASHBAR = 'UPDATE_FLASHBAR';
export const UPDATE_REVIEW_TAB = 'UPDATE_REVIEW_TAB';
export const UPDATE_REVIEW_CATEGORY_COUNT = 'UPDATE_REVIEW_CATEGORY_COUNT';
export const AUTO_LOGOUT= "AUTO_LOGOUT"
type BreadCrumbProps = {
  path: string;
  name: string;
};

type DownloadProps = {
  isShow: boolean;
  downloadGuid: string;
};

type FlashbarProps = {
  isOpen: boolean;
  message: string;
  type: string;
};

type reviewTabProps = {
  tabName?: string;
  siteOrgIndexID?: string;
  categoryID?: string;
  keywordID?: string;
};

type tokenInfoProps = {
  accessToken: string;
  expiresIn: number;
  userInfo: {
    id: string;
    firstName: string;
    lastName: string;
    userName: string;
    organizationId: string;
    role: number;
    profileImage: string;
  };
};
export function updateIsLoading(status: boolean) {
  return {
    type: UPDATE_IS_LOADER,
    payload: status,
  };
}
export function update_breadcrumb(crumbs: BreadCrumbProps[]) {
  return {
    type: UPDATE_BREADCRUMB,
    payload: crumbs,
  };
}
export function updateAutoLogout(autoLogout: boolean){

  return {
    type : AUTO_LOGOUT,
    payload: autoLogout,
  }
}
export function updateSidebarTab(tab: string) {
  return {
    type: UPDATESIDEBARTAB,
    payload: tab,
  };
}

export function sidebarLayoutChange(status: boolean) {
  return {
    type: SIBEBAR_LAYOUT_CHANGE,
    payload: status,
  };
}
export function responsiveSidebarChange(status: boolean) {
  return {
    type: UPDATE_RESPONSIVE_SIDEBAR,
    payload: status,
  };
}
export function updateTokenInfo(data: tokenInfoProps) {
  return {
    type: UPDATE_TOKEN_INFO,
    payload: data,
  };
}

export function updateDownloadID(data: DownloadProps) {
  return {
    type: UPDATE_DOWNLOAD_ID,
    payload: data,
  };
}
export function updateFlashBar(data: FlashbarProps) {
  return {
    type: UPDATE_FLASHBAR,
    payload: data,
  };
}
export function updateReviewTab(data: reviewTabProps) {
  return {
    type: UPDATE_REVIEW_TAB,
    payload: data,
  };
}
export function updateReviewCategoryCount(data: number) {
  return {
    type: UPDATE_REVIEW_CATEGORY_COUNT,
    payload: data,
  };
}
export function initializeStore() {
  return {
    type: INITIALIZE_STORE,
  };
}
